import { render } from "./EndpointDashboard.vue?vue&type=template&id=3f098c8a"
import script from "./EndpointDashboard.vue?vue&type=script&lang=js"
export * from "./EndpointDashboard.vue?vue&type=script&lang=js"

import "./EndpointDashboard.vue?vue&type=style&index=0&id=3f098c8a&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__